import { useCallback } from "react";
import AccountMpProvider from "@/core/data-provider/data-mp/account/account-mp-provider";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import { setSocialClub } from "@/domains/auth/slice";

export default function useGetSocialClub() {
  const dispatch = useAppDispatch();

  const getSocialClub = useCallback(async () => {
    const response = await AccountMpProvider.getSocialClub();
    if (response instanceof RpcMpProviderSuccessResponse) {
      dispatch(setSocialClub(response.data.socialClub));
    }
  }, [dispatch]);

  return { getSocialClub };
}
